<template>
  <div class="menumanage-page">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>菜单管理</span>
      </div>
      <div class="card">
        <div class="leftcard">
          <el-button @click="append(data, 1)" type="success" icon="el-icon-plus">顶级菜单</el-button>
          <el-button @click="append(data, 0)" type="primary" icon="el-icon-plus">子菜单菜单</el-button>
          <div class="trees">
            <el-tree class="tree" ref="tree" :data="data" :default-checked-keys="checkedArray" :check-strictly="false" icon-class="form" show-checkbox node-key="bizId" :default-expand-all="true" :props="defaultProps" :expand-on-click-node="true" :render-content="renderContent" @check-change="threeCheck" @node-click="handleNodeClick" @check="selectCheck">
            </el-tree>
          </div>
        </div>
        <div class="rightcard">
          <el-card>
            <div slot="header" class="clearfix">
              <span>{{ form.label }}</span>
            </div>
            <el-form ref="dataForm" :model="form" label-width="80px" :rules="rules">
              <el-form-item label="上级菜单">
                {{form.parentName}} <span v-if="(form.parentName==undefined||form.parentName==null||form.parentName=='')">请从左侧选择父级别菜单</span>
                <!-- <el-input v-model="form.name"></el-input> -->
              </el-form-item>
              <el-form-item label="页面名称" prop="title">
                <el-input v-model="form.title" maxlength="255"></el-input>
              </el-form-item>
              <el-form-item label="页面路径" maxlength="255" prop="component">
                <el-row>
                  <el-col :span="18">
                    <el-input maxlength="255" v-model="form.component"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <span style="color:red;margin-left:10px" v-if="form.parentName=='无'">注：顶级菜单为view下文件夹目录</span>
                    <span style="color:red;margin-left:10px" v-if="form.parentName!='无'">注：子菜单为view下文件路径</span>
                  </el-col>
                </el-row>

              </el-form-item>
              <el-form-item label="页面链接" prop="path">
                <el-input v-model="form.path" maxlength="255" :disabled="form.parentName=='无'"></el-input>
              </el-form-item>
              <el-form-item label="排 序 码" prop="sortOrder">
                <el-input style="width:200px" maxlength="10" v-model="form.sortOrder"></el-input>
              </el-form-item>
              <el-form-item label="页面图标" prop="icon">
                <el-input style="width:200px" maxlength="50" v-model="form.icon"></el-input>
              </el-form-item>
              <el-form-item label="是否启用" prop="status">
                <el-switch v-model="form.status"></el-switch>
              </el-form-item>
              <el-form-item label="是否显示" prop="hidden">
                <el-switch v-model="form.hidden"></el-switch>
              </el-form-item>
              <el-form-item>
                <el-button v-if="this.form.label != '菜单编辑'" @click="onMenuAdd" type="primary">提交添加</el-button>
                <el-button v-if="this.form.label == '菜单编辑'" @click="onMenuUpdate" type="primary">保存修改</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'MenuManage',
  data() {
    return {
      data: [],
      form: {
        label: '菜单编辑',
        parentName: '',
        parentId: '', // 父id
        name: '', // 页面名称
        type: '0', // 类型:-1菜单 0子菜单
        sortOrder: null, // 排序
        component: '', // 实际路径
        path: '', // url路径
        title: '', // 标题-菜单名称
        icon: '', // 图标
        level: null, // 级别
        buttonType: null, // 按钮类型
        status: true, // 启用、禁用状态
        redirect: null, // 启用、禁用状态
        hidden: false // 启用、禁用状态
      },
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      checkedArray: [],
      rules: {
        title: [{ required: true, message: ' ', trigger: 'blur' }],
        component: [{ required: true, message: ' ', trigger: 'blur' }],
        path: [{ required: true, message: ' ', trigger: 'blur' }],
        sortOrder: [{ required: true, message: ' ', trigger: 'blur' }],
        // icon: [{ required: true, message: ' ', trigger: 'blur' }], // status
        status: [{ required: true, message: ' ', trigger: 'change' }] // status
      }
    }
  },
  mounted() {
    this.getMentTree()
  },
  methods: {
    // 1. 加载菜单
    getMentTree() {
      this.getRequest('sys/permission/getAllList').then(res => {
        // console.log('加载菜单：' + JSON.stringify(res))
        if (res.code == 200) {
          this.data = res.data
        }
      })
    },
    // 2. 打开添加
    append(data, value) {
      if (value == 1) {
        this.form = {
          label: '添加顶级菜单',
          parentName: '无',
          parentId: '0', // 父id
          name: '', // 页面名称
          type: '-1', // 类型:-1菜单 1子菜单
          sortOrder: null, // 排序
          component: '', // 实际路径
          path: '/home', // url路径
          title: '', // 标题-菜单名称
          icon: 'lxy-shezhi', // 图标
          level: 0, // 级别
          buttonType: null, // 按钮类型
          status: true, // 启用、禁用状态
          redirect: null, // 启用、禁用状态
          hidden: false // 启用、禁用状态
        }
      } else if (value == 0) {
        this.form = {
          label: '添加子菜单',
          parentName: '',
          parentId: '', // 父id
          name: '', // 页面名称
          type: '0', // 类型:-1菜单 1子菜单
          sortOrder: null, // 排序
          component: '', // 实际路径
          path: '', // url路径
          title: '', // 标题-菜单名称
          icon: '', // 图标
          level: null, // 级别
          buttonType: null, // 按钮类型
          status: true, // 启用、禁用状态
          redirect: null, // 启用、禁用状态
          hidden: false // 启用、禁用状态
        }
      }
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields()
      }
    },
    // 2.1 选择上级菜单
    handleNodeClick(data) {
      if (this.form.label == '添加子菜单') {
        this.form.parentName = data.title
        this.form.parentId = data.id
        this.form.level = Number(data.level) + 1
      }
    },
    // 3. 提交添加
    onMenuAdd() {
      // console.log('提交：' + JSON.stringify(this.form))
      if (
        this.form.parentId == undefined ||
        this.form.parentId == null ||
        this.form.parentId == ''
      ) {
        this.$notify({
          title: '提示',
          message: '请先从左侧选择父级菜单',
          type: 'error',
          duration: 2000
        })
        return false
      }

      if (Number(this.form.sortOrder).toString() == 'NaN') {
        this.$notify({
          title: '提示',
          message: '排序只能是数字',
          type: 'error',
          duration: 2000
        })
        return false
      }

      // 执行添加
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          //
          this.form.status ? (this.form.status = 1) : (this.form.status = 0)
          this.post('sys/permission/add', this.form).then(res => {
            if (res.code == 200) {
              this.append(null, this.form.label == '添加顶级菜单' ? 1 : 0)
              this.$message({
                duration: 10000,
                message: '添加成功',
                type: 'success'
              })
              // 刷新左侧菜单
              this.getMentTree()
            } else {
              this.$notify({
                title: '提示',
                message: res.msg,
                type: 'error',
                duration: 2000
              })
            }
          })
        }
      })
    },
    // 4. 打开修改
    edit(data) {
      // 加载选择项目
      this.$refs.tree.setCheckedNodes([data])
      // console.log('选择修改：' + JSON.stringify(data))
      data.label = '菜单编辑'
      data.status = data.status == 1
      if (data.parentId == '0') {
        data.parentName = '无'
      }
      this.form = data
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields()
      }
    },
    // 5. 提交修改菜单
    onMenuUpdate() {
      if (
        this.form.parentId == undefined ||
        this.form.parentId == null ||
        this.form.parentId == ''
      ) {
        this.$notify({
          title: '提示',
          message: '请先从左侧选择父级菜单',
          type: 'error',
          duration: 2000
        })
        return false
      }
      // 执行修改
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          //
          this.form.status ? (this.form.status = 1) : (this.form.status = 0)
          this.post('sys/permission/edit', this.form).then(res => {
            if (res.code == 200) {
              this.form = {
                label: '菜单编辑',
                parentName: '无',
                parentId: '0', // 父id
                name: '', // 页面名称
                type: '-1', // 类型:-1菜单 1子菜单
                sortOrder: null, // 排序
                component: '', // 实际路径
                path: '/home', // url路径
                title: '', // 标题-菜单名称
                icon: 'lxy-shezhi', // 图标
                level: 0, // 级别
                buttonType: null, // 按钮类型
                status: true, // 启用、禁用状态
                redirect: null, // 启用、禁用状态
                hidden: false // 启用、禁用状态
              }
              this.$message({
                duration: 10000,
                message: '修改成功',
                type: 'success'
              })
              // 刷新左侧菜单
              this.getMentTree()
            } else {
              this.$notify({
                title: '提示',
                message: res.msg,
                type: 'error',
                duration: 2000
              })
            }
          })
        }
      })
    },
    // 6. 执行删除
    remove(node, data) {
      if (data.children != undefined && data.children.length > 0) {
        this.$notify({
          title: '提示',
          message: '请先删除当前菜单下属的所有子菜单',
          type: 'error',
          duration: 2000
        })
        return
      }
      this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          //  console.log('data:' + JSON.stringify(data))
          this.deleteRequest('sys/permission/delByIds/' + data.id, {
            ids: data.id
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                duration: 10000,
                type: 'success',
                message: '删除成功!'
              })
              this.getMentTree()
            } else {
              this.$notify({
                title: '提示',
                message: res.msg,
                type: 'error',
                duration: 2000
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            duration: 10000,
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 加载树子节点
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span class="node-li">{node.label}</span>
          <span>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.append(data)}
            >
              <i class="el-icon-plus"></i>
            </el-button>
            <el-button size="mini" type="text" on-click={() => this.edit(data)}>
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.remove(node, data)}
            >
              <i class="el-icon-delete"></i>
            </el-button>
          </span>
        </span>
      )
    },
    // 复选框选择事件--暂无用
    selectCheck(data, type) {
      this.checkedArray = type.checkedKeys
    },
    // 树单选--暂无用
    threeCheck(data, checked, node) {
      if (checked) {
        // this.$refs.tree.setCheckedNodes([data])
        // this.edit(data)
      }
    }
  }
}
</script>

<style lang="scss">
.menumanage-page {
  .box-card {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .clearfix {
      font-size: 16px;
    }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 20px;
      .node-li {
        display: inline-block;
        margin-right: 20px;
      }
    }
    .card {
      display: flex;
      justify-content: space-between;
      height: calc(100% - 30px);
      padding-bottom: 20px;
      .leftcard {
        width: 20%;
        height: 100%;
        margin-right: 20px;
        overflow: hidden;
        padding: 10px;
        box-sizing: border-box;
        box-shadow: 2px 2px 10px #ccc;
        .trees {
          width: calc(100% + 30px);
          height: 66vh;
          overflow: auto;
          padding: 10px 0;
          padding-right: 10px;
        }
      }
      .rightcard {
        flex: 1;
        height: auto;
      }
    }
  }
  .pagination {
    margin-top: 20px;
    margin-bottom: -20px;
    display: flex;
    justify-content: flex-end;
    .elpagination {
      padding: 0;
      margin-right: -5px;
    }
  }
  .search {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 10px;
    margin-top: -30px;
    .search-input {
      width: 30%;
      margin-right: 10px;
    }
  }
}
</style>
